import { render } from "./roles.vue?vue&type=template&id=182743d0&scoped=true"
import script from "./roles.vue?vue&type=script&lang=js"
export * from "./roles.vue?vue&type=script&lang=js"

import "./roles.vue?vue&type=style&index=0&id=182743d0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-182743d0"

export default script